// extracted by mini-css-extract-plugin
export default {"switches":"TogglableValuesItemCard_switches__wtkA1","secondaryText":"TogglableValuesItemCard_secondaryText__JUrty","saveButton":"TogglableValuesItemCard_saveButton__mXVIz"};